module.exports = __webpack_public_path__ + "static/image-kinetik-3d68bbe25b528361a79a19aa0e0a4b64.jpg";